import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VCard, {
    staticClass: "mb-10 elevation-2"
  }, [_c(VCardTitle, {
    staticClass: "card-title",
    on: {
      click: function click($event) {
        _vm.tableShown = !_vm.tableShown;
      }
    }
  }, [_vm._v(" " + _vm._s("".concat(_vm.title, " (").concat(_vm.items.length, ")")) + " "), _c(VSpacer), [!_vm.tableShown ? _c(VIcon, {
    staticClass: "toggle-table-icon"
  }, [_vm._v("mdi mdi-eye")]) : _c(VIcon, {
    staticClass: "toggle-table-icon"
  }, [_vm._v("mdi mdi-eye-off")])]], 2), _c(VExpandTransition, [_c("section", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.tableShown,
      expression: "tableShown"
    }]
  }, [_c("div", {
    staticClass: "filters-section ma-4"
  }, [_c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      "append-icon": "mdi-magnify",
      label: "Search",
      placeholder: "Filename or ".concat(this.documentType, " name"),
      "hide-details": "auto",
      clearable: ""
    },
    on: {
      "click:append": function clickAppend($event) {
        return _vm.ApplyFilters();
      },
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.ApplyFilters();
      },
      "click:clear": function clickClear() {
        _vm.filters.search = null;
        _vm.ApplyFilters();
      }
    },
    model: {
      value: _vm.filters.search,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "search", $$v);
      },
      expression: "filters.search"
    }
  }), _c(VCombobox, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.documentTags,
      "item-value": "id",
      "item-text": "name",
      "hide-details": "auto",
      multiple: "",
      "small-chips": "",
      "deletable-chips": "",
      label: "Add some tags",
      clearable: "",
      small: ""
    },
    on: {
      change: function change($event) {
        return _vm.ApplyFilters();
      },
      "click:clear": function clickClear() {
        _vm.filters.selectedTags = [];
        _vm.ApplyFilters();
      }
    },
    model: {
      value: _vm.filters.selectedTags,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "selectedTags", $$v);
      },
      expression: "filters.selectedTags"
    }
  })], 1), _vm.loading ? _c(VSkeletonLoader, {
    staticClass: "ma-4",
    attrs: {
      "max-width": "100%",
      type: "image"
    }
  }) : _vm._e(), !_vm.loading ? _c(VDataTable, {
    attrs: {
      headers: _vm.headers,
      items: _vm.items,
      "item-key": "id",
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "multi-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.filename",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", {
          staticClass: "filename-column"
        }, [_c(VTooltip, {
          attrs: {
            top: ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref2) {
              var on = _ref2.on,
                attrs = _ref2.attrs;
              return [_c(VIcon, _vm._g(_vm._b({
                attrs: {
                  small: ""
                },
                on: {
                  click: function click($event) {
                    return _vm.openFileUrl(item.url);
                  }
                }
              }, "v-icon", attrs, false), on), [_vm._v(" fa-external-link-alt ")])];
            }
          }], null, true)
        }, [_c("span", [_vm._v("Open file")])]), _c(VChip, {
          staticClass: "drawer-file-chip",
          attrs: {
            label: ""
          },
          on: {
            click: function click($event) {
              return _vm.openFileUrl(item.url);
            }
          }
        }, [_c(VIcon, {
          attrs: {
            left: ""
          }
        }, [_vm._v("mdi-file")]), _vm._v(" " + _vm._s(item.filename) + " ")], 1)], 1)];
      }
    }, {
      key: "item.tag",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c("div", [item.tag ? _c(VChip, {
          staticClass: "drawer-file-chip tag",
          attrs: {
            label: ""
          }
        }, [_c(VIcon, {
          staticClass: "tag-icon",
          attrs: {
            left: "",
            small: ""
          }
        }, [_vm._v("mdi-tag")]), _vm._v(" " + _vm._s(item.tag.name) + " ")], 1) : _vm._e()], 1)];
      }
    }, {
      key: "item.content",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c("div", [_c(VTooltip, {
          attrs: {
            top: ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref5) {
              var on = _ref5.on,
                attrs = _ref5.attrs;
              return [_c("router-link", {
                staticClass: "router-link",
                attrs: {
                  to: _vm.goToItemDetails(item),
                  target: "_blank"
                }
              }, [_c("span", _vm._g(_vm._b({}, "span", attrs, false), on), [_vm._v(_vm._s(_vm.getItemName(item)))])])];
            }
          }], null, true)
        }, [_c("span", [_vm._v(_vm._s("Open ".concat(_vm.documentType)))])])], 1)];
      }
    }], null, true)
  }) : _vm._e()], 1)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };